import type { UseFormReturn } from 'react-hook-form'
import { fieldLabels } from '@/features/consignment-form/labels'
import type { Consignment } from '@/features/consignment-form/schema'
import { t } from '@/lang'
import { SegmentedControl } from '@/ui/SegmentedControl'
import { Section } from '@/ui/Section'

const payers = [
  { value: 'SHIPPER', label: t('payment.payer.shipper') },
  { value: 'CONSIGNEE', label: t('payment.payer.consignee') },
] as const

// Invoice is the only method at go live; card payment belongs to a later phase.
const methods = [
  { value: 'CARD', label: t('payment.method.card'), disabled: true },
  { value: 'INVOICE', label: t('payment.method.invoice') },
] as const

export function PaymentSection({ form }: { form: UseFormReturn<Consignment> }) {
  const { setValue, watch } = form

  return (
    <Section title={t('payment.title')}>
      <div className="grid gap-5 md:grid-cols-2 md:gap-7.5 lg:grid-cols-3">
        <SegmentedControl
          name="paidBy"
          label={fieldLabels.paidBy}
          required
          options={payers}
          value={watch('paidBy')}
          onChange={(value) => setValue('paidBy', value, { shouldDirty: true })}
        />
        <SegmentedControl
          name="paymentMethod"
          label={fieldLabels.paymentMethod}
          required
          options={methods}
          value={watch('paymentMethod')}
          onChange={(value) => setValue('paymentMethod', value, { shouldDirty: true })}
        />
      </div>
    </Section>
  )
}
